import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { makeUniqueMessage } from "../../../utils/makeUnique";
import Message from "./Message";
import { useEffect, useState } from "react";
import { messagesApi } from "../../../features/messages/messagesApi";

export default function Messages({ messages = [], totalCount, id }) {
  const { user } = useSelector((state) => state.auth) || {};
  const { email } = user || {};
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const dispatch = useDispatch();
  const { receiver, sender } = messages[0];
  const myMessages = messages.filter(
    (ms) =>
      (ms?.receiver?.email === receiver.email &&
        ms?.sender?.email === sender.email) ||
      (ms?.receiver?.email === sender.email &&
        ms?.sender?.email === receiver.email)
  );

  const fetchMore = () => {
    setPage((prevPage) => prevPage + 1);
  };

  useEffect(() => {
    if (page > 1) {
      dispatch(
        messagesApi.endpoints.getMoreMessages.initiate({
          id,
          page,
        })
      );
    }
  }, [id, page, dispatch]);

  useEffect(() => {
    if (totalCount > 0) {
      const more =
        Math.ceil(
          totalCount / Number(process.env.REACT_APP_MESSAGES_PER_PAGE)
        ) > page;

      setHasMore(more);
    }
  }, [totalCount, page]);

  return (
    <div className="relative w-full h-[calc(100vh_-_197px)] p-6  flex flex-col-reverse">
      <ul className="space-y-2">
        <InfiniteScroll
          dataLength={messages.length}
          next={fetchMore}
          style={{ display: "flex", flexDirection: "column-reverse" }}
          inverse={true}
          hasMore={hasMore}
          loader={<h4>Loading...</h4>}
          height={window.innerHeight - 230}
        >
          {makeUniqueMessage(myMessages)
            .slice()
            .sort((a, b) => b.timestamp - a.timestamp)
            .map((message) => {
              const { message: lastMessage, id, sender } = message || {};

              const justify = sender.email !== email ? "start" : "end";
              const bg =
                sender.email !== email ? "bg-green-100" : "bg-teal-100";
              return (
                <Message
                  key={id}
                  justify={justify}
                  message={lastMessage}
                  bg={bg}
                />
              );
            })}
        </InfiniteScroll>
      </ul>
    </div>
  );
}
